module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_perform.js
// module id = 658
// module chunks = 48 49 50 51